/**
 * <recently-viewed> — remembers which products a visitor opened and shows them again.
 *
 * Record mode (product page):
 *   <recently-viewed data-record="handle" hidden><template>…card (snippets/recent-card.liquid)…</template></recently-viewed>
 *   Stores the card markup in localStorage under the handle, newest first (max 12).
 *
 * Display mode:
 *   <recently-viewed data-limit="10" hidden> … [data-carousel-track] … </recently-viewed>
 *   Fills the carousel track with the stored cards and reveals itself; stays hidden when there is nothing to show.
 */
const STORAGE_KEY = "steamrs:recently-viewed:v1";
const MAX_STORED = 12;

function readItems() {
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    return Array.isArray(stored)
      ? stored.filter((item) => item && typeof item.handle === "string" && typeof item.html === "string")
      : [];
  } catch {
    return [];
  }
}

function writeItems(items) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, MAX_STORED)));
  } catch {
    /* storage unavailable or full: nothing to remember */
  }
}

class RecentlyViewed extends HTMLElement {
  connectedCallback() {
    const handle = this.dataset.record;
    if (handle) {
      this.record(handle);
      return;
    }
    this.render();
  }

  record(handle) {
    const template = this.querySelector("template");
    const html = template ? template.innerHTML.trim() : "";
    if (!html) return;
    writeItems([{ handle, html }, ...readItems().filter((item) => item.handle !== handle)]);
  }

  render() {
    const track = this.querySelector("[data-carousel-track]");
    if (!track) return;

    const exclude = this.dataset.exclude || "";
    const limit = Number(this.dataset.limit) || 10;
    const items = readItems().filter((item) => item.handle !== exclude).slice(0, limit);
    if (items.length === 0) return;

    track.innerHTML = items.map((item) => item.html).join("");
    this.hidden = false;
  }
}

if (!customElements.get("recently-viewed")) {
  customElements.define("recently-viewed", RecentlyViewed);
}
